// extracted by mini-css-extract-plugin
export default {"themeSlider":"themeSlider_themeSlider__TQI18","themeFlex":"themeSlider_themeFlex__5PyLY"};